module.exports = __webpack_public_path__ + "img/logo-orange-yellow-svg.6ee7cd5d.svg";